export enum BindingTypeEnum {
  none = "NONE",
  B2B = "B2B",
  B2C = "B2C"
}